/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Receivelist_Releases1Inputs */

const id_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi rilis game`)
};

const ms_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan keluaran permainan`)
};

const da_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiludgivelsesnotifikationer`)
};

const de_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen zu Spielveröffentlichungen`)
};

const en_us2_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game release notifications`)
};

const es_es2_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones de lanzamientos de juegos`)
};

const es_mx2_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones de lanzamientos de juegos`)
};

const fil_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga notipikasyon sa paglabas ng laro`)
};

const fr_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications de sorties de jeux`)
};

const it_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche di uscita giochi`)
};

const hu_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékmegjelenési értesítések`)
};

const nl_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen van gamereleases`)
};

const no_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsler om spillutgivelser`)
};

const pl_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia o premierach gier`)
};

const pt_br2_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações de lançamento de jogos`)
};

const pt_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações de lançamentos de jogos`)
};

const ro_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări lansări jocuri`)
};

const fi_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelien julkaisuilmoitukset`)
};

const sv_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiser om spelrelease`)
};

const vi_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo phát hành game`)
};

const tr_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun çıkış bildirimleri`)
};

const cs_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení o vydáních her`)
};

const bg_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известия за издаване на игри`)
};

const ru_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления о выходе игр`)
};

const uk_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення про вихід ігор`)
};

const ar_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشعارات إصدارات الألعاب`)
};

const hi_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम रिलीज़ सूचनाएँ`)
};

const th_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนการวางจำหน่ายเกม`)
};

const ja_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームリリース通知`)
};

const zh_cn2_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏发布通知`)
};

const zh_hant1_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊戲發布通知`)
};

const ko_notifications_receivelist_releases1 = /** @type {(inputs: Notifications_Receivelist_Releases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 출시 알림`)
};

/**
* | output |
* | --- |
* | "Game release notifications" |
*
* @param {Notifications_Receivelist_Releases1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_receivelist_releases1 = /** @type {((inputs?: Notifications_Receivelist_Releases1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Receivelist_Releases1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_receivelist_releases1(inputs)
	if (locale === "ms") return ms_notifications_receivelist_releases1(inputs)
	if (locale === "da") return da_notifications_receivelist_releases1(inputs)
	if (locale === "de") return de_notifications_receivelist_releases1(inputs)
	if (locale === "en-US") return en_us2_notifications_receivelist_releases1(inputs)
	if (locale === "es-ES") return es_es2_notifications_receivelist_releases1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_receivelist_releases1(inputs)
	if (locale === "fil") return fil_notifications_receivelist_releases1(inputs)
	if (locale === "fr") return fr_notifications_receivelist_releases1(inputs)
	if (locale === "it") return it_notifications_receivelist_releases1(inputs)
	if (locale === "hu") return hu_notifications_receivelist_releases1(inputs)
	if (locale === "nl") return nl_notifications_receivelist_releases1(inputs)
	if (locale === "no") return no_notifications_receivelist_releases1(inputs)
	if (locale === "pl") return pl_notifications_receivelist_releases1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_receivelist_releases1(inputs)
	if (locale === "pt") return pt_notifications_receivelist_releases1(inputs)
	if (locale === "ro") return ro_notifications_receivelist_releases1(inputs)
	if (locale === "fi") return fi_notifications_receivelist_releases1(inputs)
	if (locale === "sv") return sv_notifications_receivelist_releases1(inputs)
	if (locale === "vi") return vi_notifications_receivelist_releases1(inputs)
	if (locale === "tr") return tr_notifications_receivelist_releases1(inputs)
	if (locale === "cs") return cs_notifications_receivelist_releases1(inputs)
	if (locale === "bg") return bg_notifications_receivelist_releases1(inputs)
	if (locale === "ru") return ru_notifications_receivelist_releases1(inputs)
	if (locale === "uk") return uk_notifications_receivelist_releases1(inputs)
	if (locale === "ar") return ar_notifications_receivelist_releases1(inputs)
	if (locale === "hi") return hi_notifications_receivelist_releases1(inputs)
	if (locale === "th") return th_notifications_receivelist_releases1(inputs)
	if (locale === "ja") return ja_notifications_receivelist_releases1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_receivelist_releases1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_receivelist_releases1(inputs)
	return ko_notifications_receivelist_releases1(inputs)
});
export { notifications_receivelist_releases1 as "notifications.receiveList.releases" }